import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { createVuetify as create } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import { getCurrentInstance } from 'vue'

import 'vuetify/styles'
import '@/variables.scss'

const vuetify = create({
  components,
  directives,
  defaults: {
    VBtn: {
      variant: 'elevated'
    },
    VCardActions: {
      VBtn: {
        variant: 'flat'
      }
    },
    VTextField: {
      variant: 'outlined'
    },
    VSelect: {
      variant: 'outlined'
    },
    global: {
      font: {
        family: 'Roboto, sans-serif'
      }
    }
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi
    }
  },
  theme: {
    defaultTheme: 'light',
    variations: {
      colors: ['primary', 'secondary', 'accent', 'error', 'warning', 'success'],
      lighten: 5,
      darken: 9
    },
    themes: {
      light: {
        colors: {
          primary: '#51b4cd',
          secondary: '#DE8244',
          accent: '#F5C242',
          error: '#B66836',
          warning: '#F5B342',
          success: '#51b4cd',
          info: '#51b4cd'
        }
      },
      dark: {
        colors: {
          primary: '#51b4cd',
          secondary: '#DE8244',
          accent: '#F5C242',
          error: '#B66836',
          warning: '#F5B342',
          success: '#51b4cd',
          info: '#51b4cd'
        }
      }
    }
  }
})

const adjust_color = (hex: string, factor: number) => {
  const r = Math.round(parseInt(hex.slice(1, 3), 16) * factor)
  const g = Math.round(parseInt(hex.slice(3, 5), 16) * factor)
  const b = Math.round(parseInt(hex.slice(5, 7), 16) * factor)
  return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`
}

const shuffle_array = <T>(array: T[]): T[] => {
  const shuffled = [...array]
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]
  }
  return shuffled
}

export const get_theme_colors = () => {
  const vuetify = getCurrentInstance()?.proxy.$vuetify
  const theme = vuetify.theme.current.colors
  const colors = [
    theme.primary,
    theme.secondary,
    theme.accent,
    theme.error,
    theme.warning,
    theme.success,
    // Generate variations with better factors
    adjust_color(theme.primary, 0.85),
    adjust_color(theme.secondary, 0.85),
    adjust_color(theme.accent, 0.85),
    adjust_color(theme.error, 0.85),
    adjust_color(theme.warning, 0.85),
    adjust_color(theme.success, 0.85),
    adjust_color(theme.primary, 0.7),
    adjust_color(theme.secondary, 0.7),
    adjust_color(theme.accent, 0.7),
    adjust_color(theme.error, 0.7),
    adjust_color(theme.warning, 0.7),
    adjust_color(theme.success, 0.7),
    adjust_color(theme.primary, 0.55),
    adjust_color(theme.secondary, 0.55),
    adjust_color(theme.accent, 0.55),
    adjust_color(theme.error, 0.55),
    adjust_color(theme.warning, 0.55),
    adjust_color(theme.success, 0.55)
  ]

  return shuffle_array(colors)
}

export default vuetify
